export default __webpack_public_path__ + "static/media/puppy-leash1.20c2a206.jpg";